import React from 'react'
import PropTypes from 'prop-types'

import { useFormContext } from 'react-hook-form'
import { Box } from '@mui/material'

import { HHFormMuiSwitch, HHFormPriceField } from 'components/form-fields/v5'
import { FIELD_WIDTH } from 'components/work-order/disposal-ticket-dialog/disposal-fee/fields/settings'

const MinimumChargeField = ({ index }) => {
  const { control, watch } = useFormContext()
  const useMinimumCharge = watch(`materials.${index}.useMinimumCharge`)

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <HHFormMuiSwitch
        sx={{ ml: 0 }}
        name={`materials.${index}.useMinimumCharge`}
        control={control}
        label="Min. charge"
        labelPlacement="start"
      />
      <HHFormPriceField
        sx={{ width: FIELD_WIDTH }}
        size="small"
        control={control}
        name={`materials.${index}.minimumCharge`}
        disabled={!useMinimumCharge}
      />
    </Box>
  )
}

MinimumChargeField.propTypes = {
  index: PropTypes.number,
}

export default MinimumChargeField
